import type { Attribution, BuildAttributionInput } from "./attribution.types";

/** 90 dias — o ciclo de decisão de um creator é de semanas, não de horas. */
export const ATTRIBUTION_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;

/** Teto por campo: cookies têm ~4 KB no total e a origem não precisa de mais que isso. */
const MAX_FIELD_LENGTH = 120;

const sanitize = (value: string | null): string | null => {
  const trimmed = value?.trim() ?? "";
  if (!trimmed) return null;
  return trimmed.slice(0, MAX_FIELD_LENGTH);
};

export function buildAttribution({
  slug,
  search,
}: BuildAttributionInput): Attribution | null {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);

  const cleanSlug = sanitize(slug);
  const fromTag = cleanSlug ? `from-${cleanSlug}` : null;

  const attribution: Attribution = {
    fromTag,
    source: fromTag ? "indicacao" : sanitize(params.get("utm_source")),
    medium: sanitize(params.get("utm_medium")),
    campaign: sanitize(params.get("utm_campaign")),
    content: sanitize(params.get("utm_content")),
    term: sanitize(params.get("utm_term")),
  };

  const hasSignal = Object.values(attribution).some((value) => value !== null);
  return hasSignal ? attribution : null;
}
